<script setup lang="ts">
import {ref} from "vue";
import {useRouter} from "vue-router";
import {getOpengraphData} from "@/Services/stimuli";
import {Icon} from "@iconify/vue";
import {Button} from "@/Components/Library";
import Str from "@/Utils/Str";
import User from "@/Models/User";

const router = useRouter();
const $user = new User();
const props = withDefaults(
    defineProps<{
        stimulus: any;
        hasMenu?: boolean;
    }>(),
    {
        hasMenu: false,
    },
);

const emit = defineEmits<{
    menu: void;
}>();

const ogMeta = ref(props.stimulus.ogMeta);
if (!ogMeta.value && props.stimulus?.data && ["url", "video"].includes(props.stimulus.type.slug)) {
    getOpengraphData(props.stimulus.id)
        .then((data) => {
            console.log(data);
            if (!ogMeta.value) {
                ogMeta.value = data;
            } else {
                Object.assign(ogMeta.value, data);
            }
        })
        .catch((error) => {
            console.error(error);
            ogMeta.value = {
                error: error,
            };
        });
}
</script>
<template>
    <div
        class="relative flex h-full grow flex-col items-start rounded-md border border-stone-300 bg-white pb-0 text-left text-xs transition dark:border-stone-800 dark:bg-stone-900"
    >
        <div
            v-if="
                ogMeta?.image ||
                (!['audio', 'document', 'question'].includes(stimulus?.type.slug) && stimulus?.files?.[0]?.url)
            "
            class="flex flex-col items-center justify-center rounded-t-md"
        >
            <img
                :src="ogMeta?.image ?? stimulus?.files?.[0]?.url"
                alt="Stimulus"
                class="aspect-video w-full rounded-t-md object-cover"
            />
            <Icon
                :icon="stimulus.type.icon"
                class="absolute right-2 top-2 h-8 w-8 text-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.9)]"
            />
        </div>
        <div
            v-else
            class="flex aspect-video w-full items-center justify-center rounded-t-md bg-askr-green bg-default bg-cover text-white"
        >
            <Icon :icon="stimulus.type.icon" class="drop--shadow-lg --mt-6 h-12 w-12" />
        </div>
        <div class="relative flex w-full grow flex-col px-4 py-3">
            <div class="flex flex-col">
                <div class="flex w-full">
                    <p class="text-[0.675rem] font-semibold uppercase">{{ stimulus.type.name }}</p>
                    <Button
                        v-if="hasMenu"
                        :icon="{
                            icon: 'pepicons-pencil:dots-y',
                            width: '24',
                        }"
                        class="!absolute right-0 top-0 ml-auto !pt-1 !ring-0"
                        @click.stop.prevent="emit('menu')"
                    />
                </div>
                <h4 class="mb-1 break-words font-bold">{{ stimulus.title }}</h4>
                <p v-if="stimulus.description" class="break-words">{{ Str.of(stimulus.description).truncate(50) }}</p>
            </div>
        </div>
        <div
            v-if="stimulus.user"
            class="absolute top-2.5 z-50 flex items-center rounded px-2 py-1 text-xs font-medium text-white"
            :class="[
                `bg-${stimulus.user?.profile?.color?.class ?? 'askr-green'}`,
                router.currentRoute.value.query.launch ? 'left-12' : 'left-2',
            ]"
        >
            <Icon v-if="stimulus.user.id === $user.id" icon="prime:user" width="14" class="mr-1" />
            {{ stimulus.user?.name }}
        </div>
    </div>
</template>
<style scoped></style>
